<template>
  <div class="pc">
    <div v-if="(spec.filters || []).length" class="pc-filters">
      <label v-for="f in spec.filters" :key="f.name" class="pc-filter">
        <span>{{ f.label || f.name }}</span>
        <select v-if="f.type === 'choice'" v-model="values[f.name]">
          <option value="">Any</option>
          <option v-for="o in f.options || []" :key="o" :value="o">{{ o }}</option>
        </select>
        <input v-else-if="f.type === 'year' || f.type === 'number'" v-model.number="values[f.name]" type="number">
        <input v-else-if="f.type === 'date'" v-model="values[f.name]" type="date">
        <input v-else v-model="values[f.name]" type="text">
      </label>
    </div>
    <div class="pc-stagebg" :style="stageStyle(spec)">
      <div ref="viewport" class="pc-viewport" :style="{ height: stageHeight + 'px' }">
      <div class="pc-canvas" :style="canvasStyle">
        <div v-for="p in spec.placements || []" :key="p.id" class="pc-place" :style="placeStyle(p)">
          <WidgetHost
            :placement="p"
            :widget="widgets[p.widget]"
            :page-id="pageId"
            :session-id="sessionId"
            :filters="values"
            :width="p.layout.w"
            :height="p.layout.h"
          />
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import WidgetHost from './WidgetHost.vue';
import { canvasHeight, canvasWidth, filterDefaults, placeStyle, stageStyle } from './pageLayout';

export default {
  name: 'PageCanvas',
  components: { WidgetHost },
  props: {
    pageId: { type: Number, default: null },
    sessionId: { type: String, default: '' },
    spec: { type: Object, required: true },
    widgets: { type: Object, default: () => ({}) },
  },
  data() {
    return { values: filterDefaults(this.spec), viewportWidth: 0 };
  },
  computed: {
    scale() {
      if (!this.viewportWidth) return 1;
      return this.viewportWidth / canvasWidth(this.spec);
    },
    stageHeight() {
      return Math.ceil(canvasHeight(this.spec) * this.scale);
    },
    canvasStyle() {
      return {
        width: canvasWidth(this.spec) + 'px',
        height: canvasHeight(this.spec) + 'px',
        transform: `scale(${this.scale})`,
      };
    },
  },
  watch: {
    spec(next) {
      this.values = filterDefaults(next);
    },
  },
  mounted() {
    this.measure();
    window.addEventListener('resize', this.measure);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.measure);
  },
  methods: {
    placeStyle,
    stageStyle,
    measure() {
      this.viewportWidth = this.$refs.viewport ? this.$refs.viewport.clientWidth : 0;
    },
  },
};
</script>

<style scoped>
.pc { display: flex; flex-direction: column; gap: 10px; }
.pc-filters { display: flex; gap: 10px; flex-wrap: wrap; }
.pc-filter { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #56534d; }
.pc-filter input, .pc-filter select { font-size: 12.5px; padding: 4px 6px; border: 1px solid #dad8d2; border-radius: 6px; background: #fff; }
.pc-viewport { position: relative; overflow: hidden; }
.pc-canvas { position: absolute; left: 0; top: 0; transform-origin: 0 0; }
.pc-place { position: absolute; }
</style>
